
export class ContactoModel {

nombre: string;
email: string;
mensaje: string;


}
